
import Vue from "vue"
import type { ProgramEvent } from "@/types/api/program"

export default Vue.extend({
  props: {
    event: { type: Object as VuePropType<ProgramEvent>, required: true },
  },
})
